<div class="TopSlider">
    <div class="slidesHolder">
        <div class="slides">

            <div class="slide" *ngFor="let item of pageDataService.topPromos">
                <a [routerLink]="item.url">
                    <img [src]="!isMobile ? item.image : item.imageMob" alt="">
                    <div class="overlay"></div>
                </a>
            </div>
        </div>

    </div>

</div>